module.exports = __webpack_public_path__ + "91366f965a9dc3bb321ba6f256d0aff3.fbx";